// Main theme JavaScript entry point
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel'; // This imports the Slick JS functionality
import 'slick-carousel/slick/slick.css'; // Import the base Slick styles
import 'slick-carousel/slick/slick-theme.css'; // Import the default Slick theme
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
import instantpage from 'instant.page';

// jQuery is provided by WordPress - no import needed

// Initialize Alpine.js immediately (needed for DOM interactions)
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// Global theme object
window.blGlobal = {
  api: `${window.location.origin}/wp-json/api`,
  screen: {
    extraSmall: 375,
    small: 640,
    medium: 768,
    large: 1024,
    extraLarge: 1280,
    extraExtraLarge: 1440,
    active: document.documentElement.clientWidth
  }
};

// Theme initialization
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Slick Carousel
  $('.slick-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });

  // Initialize AOS
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: true,
    offset: 100
  });
  
  // Initialize GLightbox for galleries only
  // This will only group elements that are inside .bl-popup-gallery containers
  GLightbox({
    selector: '.bl-popup-gallery .bl-popup',
    loop: true
  });

  // Initialize GLightbox for single items (outside of galleries)
  // This ensures individual .bl-popup elements are treated as single items
  GLightbox({
    selector: '.bl-popup:not(.bl-popup-gallery .bl-popup)',
    loop: false
  });
  
  // Instant.page is automatically initialized on import
  // It preloads pages on hover for faster navigation
  // No additional configuration needed for basic functionality
  
  // Initialize theme functionality
  console.log('Bananaland theme initialized');
  
  // Mobile viewport optimization
  if (/iPhone|iPad|iPod|Android/.test(navigator.userAgent)) {
    // Calculate actual viewport height for better responsive design
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    
    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', () => {
      // Small delay to ensure orientation change is complete
      setTimeout(setViewportHeight, 100);
    });
  }
});

// Initialize theme functionality
console.log('Bananaland theme loaded');